import AIP_DJAPI,{AIP_DJAPI_URLS} from '../../../api/aipDjapi'

export function getAppraisalInfo(token){
  let url = `${AIP_DJAPI_URLS.APPRAISAL_INFO}/${token}`
  return AIP_DJAPI(
    url,
    {
      method: "GET",
      headers:{
        Accept: 'application/json',
      }
    }
  )
}

export default {
  getAppraisalInfo,
}
